<template>
<div class="cx_stock_schedule">
  <!-- 棚卸対象外商品の場合は非活性 -->
  <b-popover  :target="target" ref="popover"  boundary="window" :placement="placement"  v-if="value" :show="value"   @shown="onPopupShown">
    <div  class="cx_stock_schedule_popup" ref="panel" :tabindex="0">
      <div v-if="!message">
        <div class="cx_stock_schedule_header">
            <div class="cx_stock_schedule_header_left">
              <span class="cx_stock_schedule_caption">{{popover_title}}</span>
              <span class="cx_stock_schedule_button left" @click="onClick('left-rapid')">«</span><span class="cx_stock_schedule_button" @click="onClick('left')">‹</span>
            　<Calendar  :value.sync="closingDate"/><span class="cx_stock_schedule_button" @click="onClick('right')">›</span><span class="cx_stock_schedule_button right" @click="onClick('right-rapid')">»</span>
            </div>

          　<div class="cx_stock_schedule_header_right">
                  <span>発注残</span><span class="cx_link_item" @click="openLink('purchaseOrder')">{{backPurchaseOrder}}</span>
                  <span>受注残</span><span class="cx_link_item" @click="openLink('salesOrder')">{{backSalesOrder}}</span>
                  <span class="annotation">(単位 : {{commodity.uom}})</span>
            </div>
        </div>

        <!-- 出荷明細(ポップオーバー) -->
        <Grid  v-if="commodity" class="cx_stock_schedule_grid" storageKey="v_items_popover_StockSchedule" :items="items" :isLoading="isLoading"  :height="150" ref="grid" :captions=" ['倉庫','月初', '振替','入荷済み','出荷済み','入荷待ち','出荷待ち', '予定在庫']" :widths="[150,80,80,80,80,80,80,80]" :showGearButton="false">  
            <GridItem slot="col0" slot-scope="{ item}">{{ item.warehouseName }}</GridItem>
            <GridItem slot="col1" slot-scope="{ item,index }" :openlink="getLink(index, 'stock')">{{ item.stockQuantity }}</GridItem>  
            <GridItem slot="col2" slot-scope="{ item }">{{ item.adjustment }}</GridItem>
            <GridItem slot="col3" slot-scope="{ item,index }" :openlink="getLink(index, 'purchaseDelivered')">{{ item.purchaseDelivered }}</GridItem>
            <GridItem slot="col4" slot-scope="{ item,index }" :openlink="getLink(index, 'salesDelivered')">{{ item.salesDelivered}}</GridItem> 
            <GridItem slot="col5" slot-scope="{ item,index }" :openlink="getLink(index, 'purchaseDelivery')">{{ item.purchaseDeliveryBacklog }}</GridItem>
            <GridItem slot="col6" slot-scope="{ item,index }" :openlink="getLink(index, 'salesDelivery')">{{ item.salesDeliveryBacklog }}</GridItem>            
            <GridItem slot="col7" slot-scope="{ item}">{{ item.scheduledQuantity }}</GridItem>         
            <!-- <GridItem slot="col7" slot-scope="{ item}">{{ item.uom }}</GridItem>                                         -->
        </Grid>       
        <span class="annotation">※振替は在庫移行・在庫移動・在庫振替・棚卸の総数です。　入荷待ち・出荷待ち・発注残・受注残は前月以前を含みます</span>
      </div>
      <div v-if="message">{{message}}</div>   
      </div>
  </b-popover>         
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/tenant/components';
import * as Common from '@/tenant/common';

@Component
export default class BtnStockSchedule extends Vue {
  @Prop({ default: null }) public commodity: Common.Commodity;
  @Prop({ default: null }) public sku: Common.SKU;  
  @Prop({ default: null }) public segment: Common.Segment;  
  @Prop({ default: false }) public value: boolean;  
  @Prop({ default: null }) public target: HTMLElement;  
  @Prop({ default: 'top' }) public placement: string;  
  @Prop({ default: false }) public requireSku: boolean;  
  @Prop({ default: null }) public stockDate: Date;  //間接的にclosingDateにバインド

  public backSalesOrder: number = 0;
  public backPurchaseOrder:number = 0;
//   public target: HTMLElement = null;
 public showPopover:boolean = false;
  public isLoading:boolean = true;
  public closingDate : Date = null;
  public items = new Array();
　public get popover_title(){
    return this.closingDate? '在庫詳細 (基準日)':'在庫詳細';
  }

  public get message() {
    if (this.requireSku && (this.commodity ==null || this.sku == null)) return '対象SKUを選択してください';
    else if (this.requireSku == false && this.commodity == null) return '対象商品を選択してください';
    else if (this.commodity && this.commodity.isNoStock) return '棚卸対象商品を選択してください';
    else return null;
  }

  @Watch('value')  
  public onShowChanged(newValue:boolean, oldValue:boolean){        
    if (newValue) {
      this.closingDate = this.stockDate ? this.stockDate : new Date(); //closingDateをセットすると自動でデータロードされる     
      // this.loadList();
    } else {
    (this.$refs.panel as  HTMLElement).removeEventListener('focusout', this.closePopup);      
    }
  }

  public loadList(){
      this.isLoading = true;
      var query = new Common.CommodityScheduleQuery2(this.closingDate,this.commodity.code,this.sku ? this.sku.code: null);
      query.segmentId = this.segment ? this.segment.id : null
      this.$api.execute(query).then(res => {
        var obj = res as Common.CommoditySchedule;
        this.backSalesOrder = obj.salesOrderBacklog;
        this.backPurchaseOrder = obj.purchaseOrderBacklog;
        this.items = obj.items;
        this.isLoading = false;
      });   
  }

  public onClick(flag:string){
    var targetDate = new Date(this.closingDate);
    if (flag == 'left-rapid') targetDate.setDate(targetDate.getDate() -7);
    else if (flag == 'left') targetDate.setDate(targetDate.getDate() -1);    
    else if (flag == 'right') targetDate.setDate(targetDate.getDate() +1);        
    else if (flag == 'right-rapid') targetDate.setDate(targetDate.getDate() +7);        

    this.closingDate = targetDate;
  }
  @Watch('closingDate')  
  public onClosingDateChanged(){
    if(this.value) this.loadList();
  }
  
  public onPopupShown(){
    (this.$refs.panel as  HTMLElement).focus();
    (this.$refs.panel as  HTMLElement).addEventListener('focusout', this.closePopup);
  }  

  public closePopup(e:any){
      if(e.relatedTarget && (e.relatedTarget as HTMLElement).className.indexOf('bs-popover-bottom')>0)
      {
          //ヘッダ部分をクリックされた場合はフォーカスバックする
          (e.target as HTMLElement).focus();
      } else if(e.relatedTarget != null && (this.target as  HTMLElement).contains(e.relatedTarget as HTMLElement)){
          //閉じてすぐ開く挙動を回避するため、親ボタン側でクローズさせる
      } else if(e.relatedTarget == null || (this.$refs.panel as  HTMLElement).contains(e.relatedTarget as HTMLElement) == false){
          //v-modelを更新する
          this.$emit('input',false);          
      }
  }
  public openLink(flag:string){
    let routeData = this.$router.resolve(this.getRoute(flag)) ;
    window.open(routeData.href, '_blank');        
  }
  public getLink(index:number,flag:string){
    if(index != this.items.length -1) return null;
    else return this.getRoute(flag);
  }  
  public getRoute(flag:string){
    var code = this.commodity.code;
    var skuCode =  this.sku ? this.sku.code : '';
    var closingDate = this.$api.formatter.formatDateTime(this.closingDate,'YYYY/MM/DD');
    var beginDate = this.$api.formatter.formatDateTime(this.closingDate.getBeginDate(),'YYYY/MM/DD');
    var endDate = this.closingDate.getBeginDate();
    endDate.setMonth(endDate.getMonth() +1);
    endDate.setDate(-1);
    var stockClosingDate =this.$api.formatter.formatDateTime(endDate,'YYYY/MM/DD');

    if (flag == 'stock') {
          return String.format('/journal/StockBalance?commodityCode={0}&skuCode={1}&closingDate={2}', code,skuCode,stockClosingDate);   
    } else if (flag == 'salesOrder') {
          return String.format('/sales/SalesOrderItem?commodityCode={0}&skuCode={1}&state={2}&scheduledDeliveryDateTo={3}', code,skuCode, Common.OrderItemStatus.SalesOrderOpen,closingDate);   
    } else if (flag == 'salesDelivery') {
          return String.format('/sales/SalesDeliveryItem?commodityCode={0}&skuCode={1}&state={2}&deliveryDateTo={3}', code,skuCode,Common.StockBalanceJournalStatus.SalesDeliveryItem,closingDate);      
    } else if (flag == 'salesDelivered') {
          return String.format('/sales/SalesDeliveryItem?commodityCode={0}&skuCode={1}&state={2}&deliveryDateTo={3}&deliveryDateFrom={4}', code,skuCode,Common.StockBalanceJournalStatus.SalesDeliveryInvoiceItem,closingDate,beginDate);                   
    } else if (flag == 'purchaseOrder') {
          return String.format('/purchase/PurchaseOrderItem?commodityCode={0}&skuCode={1}&state={2}&scheduledDeliveryDateTo={3}', code,skuCode, Common.OrderItemStatus.PurchaseOrderOpen,closingDate);           
    } else if (flag == 'purchaseDelivery') {
          return String.format('/purchase/PurchaseDeliveryItem?commodityCode={0}&skuCode={1}&state={2}&deliveryDateTo={3}', code,skuCode,Common.StockBalanceJournalStatus.PurchaseDeliveryNotCompleted,closingDate);         
    } else if (flag == 'purchaseDelivered') {
          return String.format('/purchase/PurchaseDeliveryItem?commodityCode={0}&skuCode={1}&state={2}&deliveryDateTo={3}&deliveryDateFrom={4}', code,skuCode,Common.StockBalanceJournalStatus.PurchasePostCompleted,closingDate,beginDate);               
    }
  }    
}
</script>
<style lang="scss">
  .cx_stock_schedule {
    .cx_stock_schedule_button{
      padding: 1px 10px;
      font-size: 12px;
    }

  }
  .cx_stock_schedule_popup {
    .cx_stock_schedule_header{
        display: flex;
        align-items: center;

        .vdp-datepicker{
            width: 120px;
            input {
              border-radius: 0px;
            }
        }
        .cx_stock_schedule_header_left{
          width:350px;
          display: flex;
          align-items: center;          
        }
        .cx_stock_schedule_header_right {
            width:100%;
            display: flex;
            justify-content: end;            
            align-items: center;
            span{
                margin: 2px 5px;
            }            
        }
        .cx_stock_schedule_caption{            
        font-size: 14px;
        margin: 3px 5px 3px 0px;
        font-weight: 700;
        width:200px;
        }   
        .cx_stock_schedule_button{
          width: 30px;
          height: 20px;
          line-height: 18px;
        background-color: #6c757d;
            border-color: #6c757d;
          margin: 0px 1px;
          text-align: center;
          vertical-align: middle;
          font-size: 14px;
          color:white;
          -webkit-user-select: none;
          // border: 1px solid transparent;
          &.left{
            border-top-left-radius: 0.25rem;;
            border-bottom-left-radius: 0.25rem;; 
            margin-right:0px;           
          }
          &.right{
            border-top-right-radius: 0.25rem;;
            border-bottom-right-radius: 0.25rem;;       
            margin-left: 0px;     
          }

          &:hover{
            cursor: pointer;
        background-color: #5a6268;
            border-color: #545b62;            
          }
        }
    }
    .cx_stock_schedule_grid{
      width: 770px;
    }
    .annotation{
      font-size: 10px;
    }
  }
.popover{
  max-width: 900px !important;
  background-color:#e2ebd2;  
  // max-height: 300px !important;

  .arrow::after {
    border-top-color:#e2ebd2;  
    border-bottom-color:#e2ebd2;      
  }
}  

</style>